// extracted by mini-css-extract-plugin
export default {"border-container":"1px solid rgb(221, 224, 230)","border-radius":"6px","container":"styles_container__PYn-S","heading":"styles_heading__ybEhs","body":"styles_body__NmQk6"};